<template>
    <div>
        <b-alert
                :show="dismissCountDown"
                dismissible
                :variant="notificationColor"
                @dismissed="dismissCountDown=0"
                @dismiss-count-down="countDownChanged"
        >
            {{ notification }}
            <ul v-if="notificationErrors" class="list-unstyled">
                <li v-for="(value, key, index) in notificationErrors">{{ value }}</li>
            </ul>
        </b-alert>

        <h1 class="my-5">Set new password</h1>

        <div v-if="loading"><img src="/loading.svg"> Loading</div>
        <div v-else>
            <p>Confirm your email and set your new password.</p>

            <validation-observer ref="observer" v-slot="{ passes }">
                <form v-on:submit.prevent="passes(savePassword)">
                    <label>Email</label>
                    <validation-provider name="email" rules="email|required" v-slot="{ errors }">
                        <b-form-input type="email" autocomplete="username" v-model="email"></b-form-input>
                        <span class="validation">{{ errors[0] }}</span>
                    </validation-provider>

                    <label class="mt-4">New password</label>
                    <validation-provider name="password" rules="min:8|required" v-slot="{ errors }">
                        <b-form-input type="password" autocomplete="new-password" v-model="password"></b-form-input>
                        <span class="validation">{{ errors[0] }}</span>
                    </validation-provider>

                    <button type="submit" class="btn btn-success  mt-4">Save new password</button>
                </form>
            </validation-observer>
        </div>

        <p class="text-muted mt-5">Remembered the password? <router-link to="/login">Sign in</router-link>.</p>
    </div>
</template>

<script>
    export default {
        data: () => ({
            token: null,
            email: '',
            password: '',
            loading: false,

            notification: null,
            notificationColor: null,
            notificationErrors: null,
            dismissSecs: 30,
            dismissCountDown: 0,
        }),
        created() {
            this.token = this.$route.params.token
        },
        methods: {
            async savePassword() {
                this.loading = true
                await this.$http.post("password/reset/process", {
                    token: this.token,
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password
                })
                .then(({data}) => {

                    if(data.status != 'ok') {

                        this.notify('Cannot save your new password. ' + data.message, 'danger')

                    } else {
                        let app = this;

                        //Run the login function
                        this.$auth.login({
                            data: {
                                email: this.email,
                                password: this.password,
                            },
                            staySignedIn: true,
                            fetchUser: true
                        })
                            .then(() => { // success

                                this.notify('Logged in', 'success') // auto redirect

                            }, () => { // error

                                // handle authentication and validation errors here
                                app.loading = false
                                this.notify('Could not login. Please reload the page and try again or contact support@boei.help', 'danger')

                            });

                    }
                })
                .catch(error => { // let the user continue when there are system errors
                    console.log(error)
                    this.notify('There seems to be a system error. Please reload the page and try again or contact support@boei.help', 'danger')
                    this.loading = false;
                })
            },

            /**
             * Notify with a message
             * @param message
             * @param color
             * @param errors
             */
            notify(message, color, errors = null) {
                this.notification = message
                this.notificationColor = color
                this.notificationErrors = errors
                this.dismissCountDown = this.dismissSecs
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
        }
    }
</script>
